/* OneClickAppInstallDialog.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { media } from '@atlaskit/primitives';
import { isCompatibleMarketplaceProduct } from '@atlassian/mpac-services-client';
import { AppDetailsAndScope } from './AppDetailsAndScope';
import { SiteSelector } from './SiteSelector/SiteSelector';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _7 = "@media (min-width:64rem){._4ap311bn{background-color:var(--ds-background-accent-gray-subtlest,#f1f2f4)}._1inivrvc{flex-direction:row}._1jsv1y6m{align-items:flex-start}}";
const _6 = "._18m91wug{overflow-y:auto}";
const _5 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _4 = "._4t3i1osq{height:100%}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._2rkou2gc{border-radius:var(--ds-space-100,8px)}";
const modalContainer = null;
export const OneClickAppInstallDialog = _ref => {
  let {
    appHeader,
    appDetails,
    compatibleProducts,
    mpacBaseUrl,
    graphQLGatewayUrl,
    links,
    stargateBasePath,
    onClose,
    isOpen,
    installAppHrefResolver,
    requestAppHrefResolver,
    onSiteSelectorFooterInstallCTAClick
  } = _ref;
  return /*#__PURE__*/_jsx(ModalTransition, {
    children: isOpen && /*#__PURE__*/_jsx(Modal, {
      onClose: onClose,
      width: "90%",
      height: "90%",
      children: /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_, _2, _3, _4, _5, _6, _7]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_2rkou2gc _1e0c1txw _2lx21bp4 _4t3i1osq _ect418aq _18m91wug _4ap311bn _1inivrvc _1jsv1y6m"]),
          children: [/*#__PURE__*/_jsx(AppDetailsAndScope, {
            appDetails: appDetails,
            appHeader: appHeader,
            graphQLGatewayUrl: graphQLGatewayUrl,
            links: links
          }), /*#__PURE__*/_jsx(SiteSelector, {
            appDetails: appDetails,
            appCompatibilities: compatibleProducts.filter(product => isCompatibleMarketplaceProduct(product)),
            mpacBaseUrl: mpacBaseUrl,
            stargateBasePath: stargateBasePath,
            links: links,
            onClose: onClose,
            installAppHrefResolver: installAppHrefResolver,
            requestAppHrefResolver: requestAppHrefResolver,
            onSiteSelectorFooterInstallCTAClick: onSiteSelectorFooterInstallCTAClick
          })]
        })]
      })
    })
  });
};